//src/styles/components/MuiTextField.js

import palette from "../palette";

const MuiTextField = {
  styleOverrides: {
    root: {
      "& .MuiOutlinedInput-root": { 
        backgroundColor: palette.background?.paper || "#ffffff", 
        transition: "all 0.3s ease", 
        "&:hover fieldset": { 
          borderColor: palette.secondary?.light || "#ffb74d", 
          borderWidth: "2px" 
        }, 
        "&.Mui-focused fieldset": { 
          borderColor: palette.primary?.main || "#1976d2", 
          borderWidth: "2px" 
        } 
      },
      "& .MuiInputLabel-root": { 
        color: palette.text?.secondary || "#757575", 
        transition: "color 0.3s ease", 
        "&.Mui-focused": { 
          color: palette.primary?.main || "#1976d2" 
        } 
      },
    },
  },
};

export default MuiTextField;